var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "daily"
  }, [_vm.theme === 'city' ? [_c('city-page-daily')] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };